import { Component } from '@angular/core';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ReportsService } from '../../Model/Reports/reports.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbDatepickerModule, NgbDateParserFormatter, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { Router } from '@angular/router';
import { DashboardService } from '../../Model/Dashboard/dashboard.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { BackgroundVerificationService } from '../../Model/BackgroundVerification/background-verification.service';
import { debug } from 'console';

@Component({
  selector: 'app-bgvverfication-report',
  standalone: true,
  imports: [NgbModule, FormsModule, CommonModule, NgbDatepickerModule, LoaderComponent, NgbDropdownModule, NgSelectModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './bgvverfication-report.component.html',
  styleUrl: './bgvverfication-report.component.scss'
})
export class BGVVerficationReportComponent {
  isDisabled: boolean = false;
  user = [] as any;
  tableData = [] as any;
  Branchs = [] as any;
  Sites = [] as any;
  Dropdown2 = [] as any;
  BgvStatus = [] as any;

  Filter = {
    SelectType: 's',
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    BranchIdsObj: null as any,
    BranchIds: null as any,
    SiteIdsObj: null as any,
    SiteIds: null as any,
    //EmpMasterIds: null,
    EmpCodes: null,
    BGVStatusObj: null as any,
    BGVStatus: null as any,
    FinalVerificationStatusObj: null as any,
    FinalVerificationStatus: null as any,
    IsDraft: true,
    UserId: null
  }

  constructor(
    private dashboard: DashboardService,
    private session: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    protected common: CommonService,
    private download: DownloadSampleService,
    private report: ReportsService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private router: Router,
    private backgroundVerification: BackgroundVerificationService,
  ) {
    this.user = this.session.GetUserDetails();
    this.common.getPageRights();
  }


  ngOnInit() {
    this.Filter.UserId = this.user.UserId;
    this.SelectDate('RegistrationDate', null, null);
    this.ESS_FillComboForAttendanceDashboard();
    this.ESS_BGVFillCombo('BS');
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);

          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj.day = parseInt(moment(response.Table[0].RegistrationDate).endOf('month').format('D'));
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_FillComboForAttendanceDashboard() {
    this.isDisabled = true;
    this.Dropdown2 = [];
    this.Branchs = [];
    this.Sites = [];
    return this.dashboard.ESS_FillComboForAttendanceDashboard({ 'SelectType': "FC" }).subscribe({
      next: (response) => {
        if (response.Table1) {
          this.Dropdown2 = response.Table1;
          this.Branchs = [...new Map(this.Dropdown2.map((e: any) => ({ BranchMasterID: e.BranchMasterID, BranchName: e.BranchName })).map((item: any) => [item.BranchMasterID, item])).values()];
          this.Sites = [...new Map(this.Dropdown2.map((e: any) => ({ SiteMasterID: e.SiteMasterID, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpBGVVerificationReportDetails() {
    if (this.Filter.FromDateObj == null) {
      this.toast.show({ message: 'Please select from date', type: toastTypeEnum.danger });
    } else if (this.Filter.ToDateObj == null) {
      this.toast.show({ message: 'Please select to date', type: toastTypeEnum.danger });
    } else {
      this.isDisabled = true;
      this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
      this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
      this.Filter.BranchIds = (this.Filter.BranchIdsObj != null && this.Filter.BranchIdsObj.length > 0) ? this.Filter.BranchIdsObj.toString() : '';
      this.Filter.SiteIds = (this.Filter.SiteIdsObj != null && this.Filter.SiteIdsObj.length > 0) ? this.Filter.SiteIdsObj.toString() : '';
      this.Filter.BGVStatus = (this.Filter.BGVStatusObj != null && this.Filter.BGVStatusObj.length > 0) ? this.Filter.BGVStatusObj.toString() : '';
      this.Filter.FinalVerificationStatus = (this.Filter.FinalVerificationStatusObj != null && this.Filter.FinalVerificationStatusObj.length > 0) ? this.Filter.FinalVerificationStatusObj.toString() : '';
      this.report.ESS_EmpBGVVerificationReportDetails(this.Filter).subscribe({
        next: (response) => {
          try {
            if (response && response.Table && response.Table.length > 0) {
              this.download.exportToExcel(response.Table, "BGV Verification Report");
            }
            else {
              this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
            }
            this.isDisabled = false;
          } catch (e) {
            this.isDisabled = false;
          }
        },
        complete() { },
        error(err) { },
      });
    }
  }

  DropdownChange(Key: String) {
    if (Key == 'Branch') {
      this.Sites = [];
      this.Filter.SiteIds = [];
      this.Sites = [...new Map(this.Dropdown2
        .filter((e: any) => {
          const branchMatch = this.Filter.BranchIds.length === 0 ||
            this.Filter.BranchIds.includes(e.BranchMasterID);
          return branchMatch;
        })
        .map((e: any) => ({ SiteMasterID: e.SiteMasterID, SiteName: e.SiteName })).map((item: any) => [item.SiteMasterID, item])).values()];
    }
  }

  CheckAll(event: any, Type: String) {
    if (Type == 'Branch') {
      if (event.target.checked) {
        this.Filter.BranchIds = this.Branchs.map((e: any) => e.BranchMasterID);
      } else {
        this.Filter.BranchIds = [];
      }
    } else if (Type == 'Site') {
      if (event.target.checked) {
        this.Filter.SiteIds = this.Sites.map((e: any) => e.SiteMasterID);
      } else {
        this.Filter.SiteIds = [];
      }
    } else if (Type == 'BGVStatus') {
      if (event.target.checked) {
        this.Filter.BGVStatus = this.BgvStatus.map((e: any) => e.Status);
      } else {
        this.Filter.BGVStatus = [];
      }
    } else if (Type == 'FinalBGVStatus') {
      if (event.target.checked) {
        this.Filter.FinalVerificationStatus = this.BgvStatus.map((e: any) => e.Status);
      } else {
        this.Filter.FinalVerificationStatus = [];
      }
    }
  }

  ESS_BGVFillCombo(SelectType: string) {
    if (SelectType == 'BS') {
      this.BgvStatus = [];
    }

    this.isDisabled = true;
    this.backgroundVerification.ESS_BGVFillCombo({ SelectType: SelectType, ESS_BGVCheckListMasterID: 0, ESS_BGVApiMasterID: 1, Id: 1 }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (SelectType == 'BS') {
            this.BgvStatus = response.Table;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.router.navigate(['reports/frontreport']);
  }
}

